<ms-scroll-adapter [msScrollSelectedInView]="activeEventId()" [stretch]="false">
    <ul class="event-list-container">
        @if (eventCarouselCustomItem()?.carouselItemTemplate && eventCarouselItems().length > 0) {
            <li
                class="event-list-item custom-list-item"
                [attr.data-menu-item-id]="eventCarouselCustomItem()?.id"
                [class.selected]="eventCarouselCustomItem()?.id === activeEventId()"
                (click)="eventCustomTileClicked.emit()">
                <ds-card
                    withHover
                    msThemedCard
                    class="event-detail-ds-card"
                    [elevated]="false"
                    [noBorderRadius]="false"
                    [themeCardElevated]="themeElevated">
                    <ng-container *ngTemplateOutlet="eventCarouselCustomItem()?.carouselItemTemplate" />
                </ds-card>
            </li>
        }
        <li
            class="event-list-item"
            *rxFor="
                let eventCarouselItem of eventCarouselItems();
                index as i;
                trackBy: trackByEventId;
                strategy: 'immediate';
                renderCallback: itemsRendered
            "
            [attr.data-menu-item-id]="eventCarouselItem.event.id"
            [class.selected]="eventCarouselItem.event.id === activeEventId()"
            (click)="tileClick(eventCarouselItem, getAdjustedIndex(i))">
            @if (eventCarouselItem.eventLink) {
                <ng-container *ngTemplateOutlet="linkTemplate; context: { $implicit: eventCarouselItem }" />
            } @else {
                <ng-container *ngTemplateOutlet="eventDetailCardTemplate; context: { $implicit: eventCarouselItem }" />
            }
        </li>
        @if (isLoading()) {
            <li class="event-list-item skeleton-item">
                <ms-event-carousel-skeleton />
            </li>
        }
    </ul>
</ms-scroll-adapter>

<ng-template #linkTemplate let-carouselItem>
    <a [vnSpeculativeLink]="carouselItem.eventLink">
        <ng-container *ngTemplateOutlet="eventDetailCardTemplate; context: { $implicit: carouselItem }" />
    </a>
</ng-template>

<ng-template #eventDetailCardTemplate let-carouselItem>
    <ds-card
        msThemedCard
        class="event-detail-ds-card"
        [clickable]="true"
        [elevated]="false"
        [border]="true"
        [radius]="true"
        [themeCardElevated]="themeElevated"
        [themedCardSurface]="cardThemeSurface">
        <ms-event-detail-card [eventCarouselItem]="carouselItem"
    /></ds-card>
</ng-template>
